import Vue from 'vue';
import { DirectiveBinding } from 'vue/types/options';
import viewportEvents, { Viewport } from '@/core/responsive/viewport/viewportEvents.service';
import breakpointsState from '@/core/responsive/breakpoints/breakpointsState.observable';

Vue.directive('fontContentSync', {
    inserted(el:HTMLElement, binding: DirectiveBinding) {
        const viewportEventHandler = function(viewport: Viewport) {
            if (!binding.value) {
                throw new Error(`Pass an array with breakpoint tuples with their min, max in px.
                Should be ordered from highest breakpoint and down.
                Example: [
                    [MIN_LG, { min: 7, max: 34 }],
                    [MIN_MD, { min: 6, max: 22 }],
                    [MIN_XS, { min: 5, max: 18 }]
                ]`);
            }
            if (!viewport.sizeChange) return; // Not interested in scroll events

            const activeSizes = binding.value.find(bpTuple => {
                return breakpointsState.isBreakpointActive(bpTuple[0]);
            });
            if (!activeSizes) return;
            const sizes = activeSizes[1];

            setFontSize(el, sizes.max);
            const isOriginallyWrapped = isWrapped(el, sizes.max);
            if (!isOriginallyWrapped) return;

            let fontSize = sizes.max;
            for (; fontSize >= sizes.min; --fontSize) {
                setFontSize(el, fontSize);
                if (!isWrapped(el, fontSize)) {
                    break; // Success - unwrapped
                }
            }
            if (isWrapped(el, fontSize)) {
                // Still wrapped with minimum font - restore to original
                setFontSize(el, sizes.max);
            }

            function isWrapped(el: HTMLElement, fontSize: number) {
                // Somewhat naive approach: If parent height is more than double the font-size it's probably wrapped.
                return el.clientHeight > fontSize * 2;
            }

            function setFontSize(el: HTMLElement, fontSizeInPx: number) {
                el.style.fontSize = fontSizeInPx + 'px';
            }
        };
        el['data-eet-event-handler'] = viewportEventHandler;
        viewportEvents.setCallback(viewportEventHandler);
    },
    unbind(el: HTMLElement) {
        viewportEvents.removeCallback(el['data-eet-event-handler']);
    }
});
